import { __experimentalFormField as FormField } from '@cp/ds/src/components/form';
import { CatalogItemType } from '@common/model/catalog/item/type';
import React from 'react';
import { Price } from 'src/shared/ui/price';
import { FormFieldName } from '../../model/form';
import { FilterRangeField } from '../filterRangeField';

const RESUME_STEP = 100;
const RESUME_STEPS_COUNT = 15;
const RESUME_MIN = 0;
const RESUME_MAX = RESUME_STEP * RESUME_STEPS_COUNT;

const VACANCY_MIN = 300;
const VACANCY_MAX = 2000;
const VACANCY_STEP = 100;

type PriceFieldProps = {
  catalogType: CatalogItemType;
};

export const PriceField: React.FC<PriceFieldProps> = ({ catalogType }) => {
  const isVacancy = catalogType === CatalogItemType.Vacancy;
  const min = isVacancy ? VACANCY_MIN : RESUME_MIN;
  const max = isVacancy ? VACANCY_MAX : RESUME_MAX;
  const step = isVacancy ? VACANCY_STEP : RESUME_STEP;

  return (
    <FormField
      name={FormFieldName.Price}
      render={({ disabled, name }) => (
        <FilterRangeField disabled={disabled} format={(value) => <Price value={value} />} max={max} min={min} name={name} step={step} />
      )}
    />
  );
};
